export enum AuthorityDashboard {
  DASHBOARD_VIEW_MANAGEMENT = '9.1',
  DASHBOARD_VIEW_FINANCEIRO = '7.1.2',
  DASHBOARD_VIEW_BUDGET = '7.1.1',
  DASHBOARD_VIEW_STANDARD = '7.1',
  DASHBOARD_VIEW = '7.',
}
